module.exports = __webpack_public_path__ + "media/should-you-post.mp3";